<template>
  <v-select
    :items="items"
    v-model="selectedEmailType"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
    item-text="name"
    item-value="id"
    label="Email Type"
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const EMAIL_TYPES = gql`
  query allEmailTypes {
    emailTypes(orderBy: { fieldName: "name", direction: ASC }) {
      totalCount
      edges {
        node {
          id
          name
          description
          subject
          template
        }
      }
    }
  }
`;

export default {
  name: "email-types-list-select",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      selectedEmailType: "",
    };
  },

  computed: {
    items() {
      return this.emailTypes && this.emailTypes.edges
        ? this.emailTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onChange() {
      const selected = this.items.find(
        (item) => item.id == this.selectedEmailType
      );
      if (selected) {
        this.$emit("select", selected);
        this.$emit("input", { ...selected });
      }
    },
  },

  apollo: {
    emailTypes: {
      query: EMAIL_TYPES,
      fetchPolicy: "network-only",
      result({ data }) {
        //https://tracker.globetrack.ie/issues/7965
        if (data.emailTypes) {
          const defaultTemplate = data.emailTypes.edges.find((edge) => {
            return edge.node.name == "Default";
          });
          if (defaultTemplate) {
            this.selectedEmailType = defaultTemplate.node.id;
            this.onChange();
          }
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/EmailTypesListSelect.vue